<template>

    <div class="step-number" :class="classes">{{ stepNumber }}</div>

</template>

<style scoped lang="scss">

    .step-number {
        @include font-bold(12px);
        align-items: center;
        background: $color-primary;
        border-radius: 50%;
        color: #fff;
        display: flex;
        height: 34px;
        justify-content: center;
        margin-right: 10px;
        width: 34px;
        &.complete {
            background: $color-success;
        }
        &.incomplete {
            background: $color-danger;
        }
    }

</style>

<script>

export default {

    props: {
        stepNumber: {
            type: Number,
            default: 1,
        },
        stepComplete: {
            type: Boolean,
            default: null,
        },
    },

    computed: {

        classes() {
            return {
                'complete': this.stepComplete === true,
                'incomplete': this.stepComplete === false,
            };
        },

    },

}

</script>
